export default __webpack_public_path__ + "images/dc3d7a47c5f9e8ca4d6672826802522b-immune.png";